/** Tenant refund /metering/finance/new-tenant-refund */
export default {
  tenantRefundPage: {
    phDateStart: 'Start date',
    phDateEnd: 'End date',
    phTenant: 'Tenant name / ID',
    phAuditStatus: 'Review status',
    btnSearch: 'Search',
    btnReset: 'Reset',
    btnExport: 'Export',
    sectionTitle: 'Tenant refunds',
    sortDefault: 'Default sort',
    colRid: 'Reference no.',
    colApplyTime: 'Applied at',
    colTenantName: 'Tenant',
    colBizType: 'Account type',
    colRefundType: 'Refund type',
    colApplyAmt: 'Requested (CNY)',
    colActualAmt: 'Actual (CNY)',
    colAuditStatus: 'Status',
    colAction: 'Actions',
    btnDetail: 'Details',
    btnAudit: 'Review',
    statusVal0: 'Pending (manager)',
    statusVal1: 'Rejected (platform)',
    statusVal2: 'Pending (platform)',
    statusVal3: 'Refunded',
    statusVal4: 'Refunding',
    statusVal5: 'Rejected (manager)',
    statusVal6: 'Cancelled by tenant',
    refundTypeCorporate: 'Corporate top-up',
    bizElectric: 'Electricity wallet',
    bizWater: 'Water wallet',
    shortcutYesterday: 'Yesterday',
    shortcutThisWeek: 'This week',
    shortcutLastWeek: 'Last week',
    shortcutThisMonth: 'This month',
    shortcutLastMonth: 'Last month',
    shortcutLast3Months: 'Last 3 months',
    shortcutLastYear: 'Last year',
    msgTenantListFail: 'Failed to load tenants',
    msgRefundListFail: 'Failed to load refunds',
    msgNoDataExport: 'No data to export',
    msgExportFail: 'Export failed',
    msgExportOk: 'Exported {count} row(s).',
    exportSheetName: 'Tenant refunds',
    filePrefix: 'TenantRefund',
    exportCurrentPage: 'Export current page',
    exportSelected: 'Export selected',
    exportAll: 'Export all',
    warnNoSelectedExport: 'Select rows to export first',
    msgExportOkSelected: 'Exported {count} selected row(s).',
    successExported: 'Exported {count} row(s).',
    successExportedLimit: 'Over {total} rows matched; exported first {count}.',
    exporting: 'Exporting…',
    msgNoAuditPerm: 'No permission to review',
    msgNoViewPerm: 'No permission to view',
    msgDetailDisabled: 'Details are hidden while pending manager review',
    msgDetailFail: 'Failed to load details',
    msgTenantAccountFail: 'Failed to load tenant account',
    detailTitle: 'Refund details',
    detailSeqInline: 'Ref no.: ',
    detailLblRid: 'Refund ref no.',
    detailLblTenantId: 'Tenant ID',
    detailLblTenantName: 'Tenant name',
    detailLblManagerName: 'Project',
    detailLblBizType: 'Account type',
    detailLblPayeeName: 'Payee name',
    detailLblBankNumber: 'Account no.',
    detailLblOpeningBank: 'Bank branch',
    detailLblProjectReviewer: 'Project reviewer',
    detailLblApplyTime: 'Applied at',
    detailLblProcessTime: 'Reviewed at',
    detailLblRefundTime: 'Refunded at',
    detailLblRealCash: 'Dedicated cash (CNY)',
    detailLblApplyAmt: 'Requested (CNY)',
    detailLblActualAmt: 'Actual (CNY)',
    detailLblAuditStatus: 'Status',
    detailLblRefuseMsg: 'Rejection reason',
    btnClose: 'Close',
    auditTitle: 'Refund review',
    auditLblApplyAmt: 'Requested amount (CNY)',
    auditLblRefundable: 'Refundable balance (CNY)',
    auditLblBankAccount: 'Bank account',
    auditLblOpeningBank: 'Bank branch',
    auditLblAccountName: 'Account name',
    auditLblOpinion: 'Decision',
    auditAgree: 'Approve',
    auditReject: 'Reject',
    auditLblRefundAmt: 'Refund amount',
    phRefundAmt: 'Enter refund amount',
    auditLblRefuseReason: 'Reason',
    phRefuseReason: 'Enter reason (max 100)',
    smsTitle: 'SMS verification',
    smsLblPhone: 'Phone',
    smsLblCode: 'Code',
    phSmsCode: 'Enter SMS code',
    btnSendCode: 'Send code',
    btnCancel: 'Cancel',
    btnConfirm: 'Confirm',
    confirmTitle: 'Notice',
    confirmOk: 'OK',
    confirmCancel: 'Cancel',
    confirmAuditPass: 'Approve this refund?',
    confirmAuditReject: 'Reject this refund?',
    ruleSelectOpinion: 'Select a decision',
    ruleRefundAmt: 'Enter refund amount',
    ruleRefuseReason: 'Enter rejection reason',
    msgFillAudit: 'Complete the review form',
    msgEnterRefundAmt: 'Enter refund amount',
    msgRefundAmtTooHigh: 'Refund cannot exceed requested amount',
    msgEnterSmsCode: 'Enter SMS code',
    msgSmsSent: 'Code sent',
    msgSmsSendFail: 'Failed to send code',
    msgOpSuccess: 'Done',
    msgOpFail: 'Operation failed',
    msgAuditFail: 'Review request failed'
  }
}
